







import { Component, Prop, Vue } from 'vue-property-decorator'
import AppDynamicHeader from '@core/components/header/AppDynamicHeader.vue'
import AppDynamicIconHeader from '@core/components/header/AppDynamicIconHeader.vue'
import { HeaderItem } from '@core/model/structure/HeaderStructure'
import KYCViewIcon from '@core/components/header/assets/kyc-view.svg'
import ResourcesIcon from '@core/components/header/assets/Icon_Resources.svg'
import ReportIcon from '@core/components/header/assets/Icon_Report.svg'
import AdminIcon from '@core/components/header/assets/admin.svg'
import ClientListIcon from '@core/components/header/assets/client-list.svg'
import AdminSettingsIcon from '@core/components/header/assets/admin-settings.svg'
import NewBusiness from '@core/components/header/assets/new_business.svg'
import NoticeIcon from '@core/components/header/assets/notice.svg'
import FAQIcon from '@core/components/header/assets/faq.svg'
import LogoutIcon from '@core/components/header/assets/logout.svg'
import { Dictionary } from 'lodash'
import API from '@core/services/API'
import { inject } from 'inversify-props'
import { IProjectSettings } from '@master/config/IProjectSettings'

@Component({
  components: {
    AppDynamicHeader,
    AppDynamicIconHeader
  }
})
export default class TheHeader extends Vue {
  @inject()
  private $api: API

  @inject()
  private projectSettings: IProjectSettings

  @Prop({ default: () => [] }) private customHeaders: HeaderItem[]
  @Prop({ default: 'KYC' }) private kycViewLabel: string

  get isModernTheme () {
    return this.projectSettings.theme === 'Modern'
  }

  get currentUser () {
    return this.$store.getters.currentUser
  }

  get isBscReviewer () {
    return this.$store.getters.isBscReviewer
  }

  get isProductAdmin () {
    return this.$store.getters.isProductAdmin
  }

  get headerStructure (): HeaderItem[] {
    return this.currentUser.systemrole === 'bsc-reviewer' ? this.bscHeaderStructure() : this.fullHeaderStructure()
  }

  bscHeaderStructure (): HeaderItem[] {
    return [
      {
        event: 'logout',
        icon: LogoutIcon,
        label: 'Exit'
      }
    ]
  }

  fullHeaderStructure (): HeaderItem[] {
    return [
      {
        href: '/live/home',
        icon: KYCViewIcon,
        label: this.kycViewLabel,
        disable: this.isBscReviewer || this.isProductAdmin,
        dropdown: [
          {
            href: '/live/home-adviser',
            label: 'Adviser View'
          },
          {
            disable: this.currentUser.systemrole === 'adviser',
            href: '/live/home-supervisor',
            label: 'Supervisor View'
          },
          {
            disable: !this.currentUser.isSuperUser,
            href: '/live/home-submission',
            label: 'Admin View'
          }
        ]
      },
      {
        href: this.getHref('User Profile', { userOid: this.currentUser.accountID }, `/live/user-profile?_oid=${this.currentUser.accountID}`),
        icon: AdminIcon,
        label: 'Profile'
      },
      {
        disable: this.currentUser.isSuperUser,
        icon: NewBusiness,
        href: '/live/client-management',
        label: 'CMS'
      },
      {
        disable: !this.currentUser.isSuperUser,
        icon: ClientListIcon,
        href: '/live/client-list',
        label: 'Clients'
      },
      {
        disable: !this.currentUser.isSuperUser,
        icon: AdminSettingsIcon,
        href: '/live/admin',
        label: 'Admin',
        dropdown: [
          {
            href: '/live/user-list',
            label: 'User Administration'
          },
          {
            href: '/live/group-list',
            label: 'Group Administration'
          },
          {
            href: '/live/sales-team-administration',
            label: 'Sales Team Administration',
            disable: !this.projectSettings.useSalesTeamAdmin
          },
          {
            href: '/live/admin-assumptions',
            label: 'Assumptions List',
            disable: !this.projectSettings.useAssumptionsList
          },
          {
            href: '/live/admin-products',
            label: 'Product List'
          },
          {
            href: '/live/admin-pdfUpload',
            label: 'PDF Upload',
            disable: this.projectSettings.useResourcesModule
          },
          {
            href: '/live/payee-list',
            label: 'Intermediaries List'
          },
          {
            href: '/live/company-codes-list',
            label: 'Product Principal List'
          },
          {
            href: '/live/agent-codes-mass-update',
            label: 'Agent Codes Mass Update'
          },
          {
            href: '/live/client-management',
            label: 'CMS',
            disable: this.projectSettings.disableCMSModule
          },
          {
            href: '/live/cpd/summary',
            label: 'CPD'
          },
          {
            href: '/live/commission-module',
            label: 'Commission Module'
          },
          {
            href: '/live/bsc-home',
            label: 'BSC Module'
          },
          {
            href: '/live/disign-panel',
            label: 'Disign Panel'
          },
          {
            href: '/live/hierarchy-setup',
            label: 'Compensation Setup',
            disable: !this.projectSettings.useHierarchySetup
          },
          {
            href: '/live/admin-survey',
            label: 'Survey',
            disable: !this.projectSettings.useKycSurvey
          },
          {
            href: '/live/scheduler',
            label: 'Scheduler',
            disable: !this.projectSettings.useScheduler
          }
        ]
      },
      ...this.customHeaders,
      {
        icon: ResourcesIcon,
        href: '/live/resources',
        label: 'Resources',
        disable: !this.projectSettings.useResourcesModule
      },
      {
        href: '/live/pdfView/SFA_APL.pdf',
        icon: NoticeIcon,
        target: '_blank',
        label: 'Notices',
        disable: this.projectSettings.useResourcesModule
      },
      {
        icon: ReportIcon,
        href: '/live/report-management',
        label: 'Report',
        disable: !this.projectSettings.useReportModule
      },
      {
        href: '/live/pdfView/FAQ.pdf',
        icon: FAQIcon,
        target: '_blank',
        label: 'FAQ'
      },
      {
        event: 'logout',
        icon: LogoutIcon,
        label: 'Exit'
      }
    ]
  }

  getHref (routeName: string, params: Dictionary<string>, legacyUrl: string) {
    const { route, href } = this.$router.resolve({
      name: routeName,
      params
    })

    return route.matched.length > 0 ? href : legacyUrl
  }

  async logout () {
    await this.$api.account.logout()
    await this.$store.dispatch('logout')
    this.$router.push({ name: 'Login' })
  }
}
